import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Text, Stack } from '@iqueue/iq-ui';
import Field from '../components/ui/Field';
import { api } from '../lib/api';
import AuthLayout from './AuthLayout';



export default function LoginPage({ onAuthed }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username || !password || busy) return;
    setBusy(true);
    setError('');
    try {
      const res = await api.login(username, password);
      if (res.mustChange) {
        navigate('/change-password', { state: { username, mustChange: true } });
        return;
      }
      await onAuthed();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Вход"
      footer={<span>Нет аккаунта? <Link to="/register">Зарегистрироваться</Link></span>}
    >
      <Stack gap={200} render={<form onSubmit={submit} />}>
          <Field label="Имя пользователя" value={username} onChange={setUsername} autoFocus required autoComplete="username" />
          <Field label="Пароль" type="password" value={password} onChange={setPassword} required autoComplete="current-password" />
          {error && <Text variant="body-small" >{error}</Text>}
          <Button type="submit" disabled={busy || !username || !password} >
            {busy ? 'Вход…' : 'Войти'}
          </Button>
      </Stack>
    </AuthLayout>
  );
}
